<div class="suggested-prompts">
    <div class="suggested-prompts__header">
        <h3 class="suggested-prompts__title">Suggested prompts</h3>
        <img
            class="suggested-prompts__refresh"
            src="/assets/icons/sync.svg"
            alt="Refresh"
            (click)="refreshPrompts()"
            [aidaTooltip]="'Refresh'"
            aidaTooltipPosition="top"
        />
    </div>
    <div class="suggested-prompts__items">
        <div
            class="suggested-prompts__item"
            *ngFor="let prompt of randomPrompts"
            (click)="handlePromptSelected(prompt.text)"
        >
            <div *ngIf="prompt.icon || prompt.category" class="suggested-prompts__item__header">
                <img
                    *ngIf="prompt.icon"
                    [src]="'/assets/icons/prompts/' + prompt.icon"
                    class="suggested-prompts__item__icon"
                    alt="Icon"
                />
                <span *ngIf="prompt.category" class="suggested-prompts__item__category">{{
                    prompt.category
                }}</span>
            </div>
            <span class="suggested-prompts__item__text">{{ prompt.text }}</span>
        </div>
    </div>
</div>
